module.exports = __webpack_public_path__ + "img/logo-v2.0a91257d.svg";